/* MINIFLACONS · PDP Lab · Effekte (Aura, Duftreise, Bento, Duft-Zwillinge, Trio, Gutschrift) */
(() => {
  'use strict';
  const MFL = window.MFL;
  if (!MFL || !MFL.data) return;
  const D = MFL.data, root = MFL.root, money = MFL.money;
  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => Array.from(el.querySelectorAll(s));
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const sstep = (a, b, x) => { const t = clamp((x - a) / (b - a)); return t * t * (3 - 2 * t); };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  const FAMC = MFL.FAMC, colOf = MFL.colOf;
  if (!FAMC || !colOf) return;
  const hex2rgb = h => { h = h.replace('#', ''); if (h.length === 3) h = h.split('').map(x => x + x).join(''); const n = parseInt(h, 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; };

  /* ------------------------------------------------ Notendaten aufbereiten */
  const clean = s => String(s || '').replace(/(kopf|herz|basis)\s*note?n?\s*:?/gi, '').replace(/\s+/g, ' ').trim();
  const split = s => clean(s).split(/\s*(?:,|;|•|·|\n|\/|\bund\b)\s*/i).map(x => x.replace(/[.:]+$/, '').trim()).filter(x => x && x.length < 42);
  const fromNames = arr => arr.map(n => ({ n, g: [] }));
  const N = D.notes || {};
  let pyramid = null, linear = null;
  if ((N.top || []).length || (N.heart || []).length || (N.base || []).length) {
    pyramid = { top: N.top || [], heart: N.heart || [], base: N.base || [] };
  } else if (N.legacy && (N.legacy.top || N.legacy.heart || N.legacy.base)) {
    pyramid = { top: fromNames(split(N.legacy.top)), heart: fromNames(split(N.legacy.heart)), base: fromNames(split(N.legacy.base)) };
  }
  if (!pyramid) {
    if ((N.linear || []).length) linear = N.linear;
    else if (N.legacy && N.legacy.all) linear = fromNames(split(N.legacy.all));
    else linear = fromNames(D.gn || []);
  }
  const allNotes = pyramid ? [...pyramid.top, ...pyramid.heart, ...pyramid.base] : linear;

  /* ------------------------------------------------ Aura (Canvas) */
  class Aura {
    constructor(canvas, dark) {
      this.c = canvas; this.ctx = canvas.getContext('2d'); this.dark = dark;
      this.blobs = Array.from({ length: 6 }, (_, i) => ({
        ph: Math.random() * 6.28, sp: .00012 + Math.random() * .00016,
        ax: .14 + Math.random() * .18, ay: .1 + Math.random() * .16,
        cx: [.22, .78, .5, .3, .72, .52][i], cy: [.3, .28, .72, .78, .7, .45][i],
        r: .36 + Math.random() * .2, col: [200, 190, 180], tgt: [200, 190, 180]
      }));
      this.visible = false; this.raf = 0; this.mx = 0; this.my = 0;
      this.resize = this.resize.bind(this); this.loop = this.loop.bind(this);
      this.resize();
      if ('ResizeObserver' in window) new ResizeObserver(this.resize).observe(canvas);
      new IntersectionObserver(([e]) => { this.visible = e.isIntersecting; this.kick(); }).observe(canvas);
      document.addEventListener('visibilitychange', () => this.kick());
    }
    resize() {
      const r = this.c.getBoundingClientRect(), s = .5;
      this.w = Math.max(2, Math.round(r.width * s)); this.h = Math.max(2, Math.round(r.height * s));
      this.c.width = this.w; this.c.height = this.h; this.draw(performance.now());
    }
    setColors(list, instant) {
      const cols = list.filter(Boolean).map(hex2rgb);
      if (!cols.length) return;
      this.blobs.forEach((b, i) => { b.tgt = cols[i % cols.length]; if (instant) b.col = b.tgt.slice(); });
      this.kick();
    }
    pointer(x, y) { this.mx = x; this.my = y; }
    kick() {
      if (reduced()) { this.blobs.forEach(b => { b.col = b.tgt.slice(); }); this.draw(0); return; }
      if (this.visible && document.visibilityState === 'visible') { if (!this.raf) this.raf = requestAnimationFrame(this.loop); }
    }
    loop(t) {
      this.raf = 0;
      this.draw(t);
      if (this.visible && document.visibilityState === 'visible' && !reduced()) this.raf = requestAnimationFrame(this.loop);
    }
    draw(t) {
      const { ctx, w, h } = this;
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, w, h);
      if (this.dark) { ctx.fillStyle = '#0a0a0b'; ctx.fillRect(0, 0, w, h); }
      ctx.globalCompositeOperation = this.dark ? 'lighter' : 'source-over';
      const m = Math.max(w, h);
      this.blobs.forEach(b => {
        for (let k = 0; k < 3; k++) b.col[k] += (b.tgt[k] - b.col[k]) * .05;
        const x = (b.cx + Math.sin(t * b.sp + b.ph) * b.ax + this.mx * .04) * w;
        const y = (b.cy + Math.cos(t * b.sp * 1.3 + b.ph) * b.ay + this.my * .04) * h;
        const r = b.r * m;
        const g = ctx.createRadialGradient(x, y, 0, x, y, r);
        const [cr, cg, cb] = b.col.map(Math.round);
        const a = this.dark ? .34 : .5;
        g.addColorStop(0, `rgba(${cr},${cg},${cb},${a})`);
        g.addColorStop(.55, `rgba(${cr},${cg},${cb},${a * .35})`);
        g.addColorStop(1, `rgba(${cr},${cg},${cb},0)`);
        ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
      });
    }
  }

  /* Hero-Aura + schwebende Noten */
  const heroCanvas = $('[data-mfl-aura]');
  const drCols = (D.dr || []).slice(0, 3).map(d => FAMC[d]).filter(Boolean);
  const noteCols = (allNotes || []).slice(0, 4).map(colOf);
  if (heroCanvas) {
    const aura = new Aura(heroCanvas, false);
    aura.setColors([...drCols, ...noteCols].slice(0, 6).concat(['#efe8dc']), true);
    const stage = $('[data-mfl-stage]');
    if (stage && window.matchMedia('(hover: hover)').matches) {
      stage.addEventListener('pointermove', e => { const r = stage.getBoundingClientRect(); aura.pointer((e.clientX - r.left) / r.width - .5, (e.clientY - r.top) / r.height - .5); });
    }
  }
  const floaters = $('[data-mfl-floaters]');
  if (floaters && allNotes && allNotes.length) {
    const spots = [{ x: '6%', y: '20%' }, { x: '64%', y: '34%' }, { x: '60%', y: '72%' }, { x: '5%', y: '64%' }];
    const pick = pyramid ? [pyramid.top[0], pyramid.heart[0], pyramid.base[0], pyramid.top[1] || pyramid.heart[1]] : allNotes.slice(0, 4);
    floaters.innerHTML = pick.filter(Boolean).slice(0, 4).map((n, i) =>
      `<span class="mfl-floater" style="--x:${spots[i].x};--y:${spots[i].y};--c:${colOf(n)};--d:${(i * 1.7).toFixed(1)}s"><span>${esc(n.n)}</span></span>`).join('');
  }

  /* ------------------------------------------------ Duftreise */
  const J = $('[data-mfl-journey]');
  if (J && allNotes && allNotes.length) {
    const strataEl = $('[data-mfl-strata]', J);
    const hl = clamp((+D.halt || 7) / 10, .3, 1);
    const LAY = pyramid ? [
      { k: 'top', label: 'Kopfnote', hint: 'erste Minuten', ghost: 'Kopf', notes: pyramid.top,
        phase: 'Der erste Eindruck', desc: 'Die flüchtigsten Moleküle – hell, präsent, schnell verflogen. Genau das riechst du direkt nach dem Aufsprühen.' },
      { k: 'heart', label: 'Herznote', hint: 'ab ca. 15 Min.', ghost: 'Herz', notes: pyramid.heart,
        phase: 'Der Charakter', desc: 'Jetzt zeigt der Duft, wer er ist. Die Herznoten tragen ihn durch die nächsten Stunden.' },
      { k: 'base', label: 'Basisnote', hint: 'ab ca. 2–3 Std.', ghost: 'Basis', notes: pyramid.base,
        phase: 'Was bleibt', desc: 'Die schwersten Moleküle halten am längsten auf Haut und Kleidung – der Eindruck, den du hinterlässt.' }
    ].filter(L => L.notes.length) : [
      { k: 'all', label: 'Akkord', hint: 'von Anfang an', ghost: 'Akkord', notes: linear,
        phase: 'Von der ersten Sekunde an', desc: 'Kein klassischer Aufbau in Kopf, Herz und Basis: Du riechst den ganzen Akkord sofort – mit der Zeit wird er nur leiser und weicher.' }
    ];
    strataEl.innerHTML = LAY.map(L => `
      <div class="mfl-stratum" data-k="${L.k}">
        <div class="mfl-stratum__label"><b>${L.label}</b><small>${L.hint}</small></div>
        <ul class="mfl-stratum__notes">${L.notes.slice(0, 7).map(n => `<li class="mfl-jnote" style="--c:${colOf(n)}">${esc(n.n)}</li>`).join('')}</ul>
      </div>`).join('');
    const rows = $$('.mfl-stratum', strataEl);
    const phaseEl = $('[data-mfl-phase]', J), descEl = $('[data-mfl-phase-desc]', J), ghost = $('[data-mfl-ghost]', J);
    const range = $('[data-mfl-range]', J), fill = $('[data-mfl-fill]', J), timeEl = $('[data-mfl-time]', J), playBtn = $('[data-mfl-play]', J);
    const darkCanvas = $('[data-mfl-aura-dark]', J);
    const aura = darkCanvas ? new Aura(darkCanvas, true) : null;
    const layCols = LAY.map(L => L.notes.slice(0, 3).map(colOf));
    J.style.setProperty('--j1', (layCols[0] || [])[0] || '#fff');
    J.style.setProperty('--j2', (layCols[1] || layCols[0] || [])[0] || '#fff');
    J.style.setProperty('--j3', (layCols[2] || layCols[layCols.length - 1] || [])[0] || '#fff');
    if (aura) aura.setColors(layCols[0].concat(layCols[0]), true);

    const X = [0, .15, .35, .6, .8, 1], M = [0, 15, 60, 180, 360, 480];
    const minutes = p => { for (let i = 1; i < X.length; i++) if (p <= X[i]) return M[i - 1] + (p - X[i - 1]) / (X[i] - X[i - 1]) * (M[i] - M[i - 1]); return 480; };
    const fmtT = p => {
      if (p >= .995) return '8 Std.+';
      const m = minutes(p);
      if (m < 1) return 'Gerade aufgesprüht';
      if (m < 60) return `nach ${Math.round(m)} Min.`;
      const h = Math.floor(m / 60), r = Math.round((m % 60) / 10) * 10;
      return r && r < 60 ? `nach ${h} Std. ${r} Min.` : `nach ${r === 60 ? h + 1 : h} Std.`;
    };
    const inten = p => pyramid ? {
      top: 1 - sstep(.05, .3, p),
      heart: sstep(.03, .2, p) * (1 - sstep(.55, .86, p) * .85),
      base: (.22 + .78 * sstep(.25, .55, p)) * (1 - (1 - hl) * sstep(.82, 1, p))
    } : { all: 1 - (1 - hl) * .85 * sstep(.55, 1, p) };

    let P = -1, activeK = '';
    function render(p) {
      p = clamp(p);
      if (Math.abs(p - P) < .0005) return;
      P = p;
      const I = inten(p);
      let best = LAY[0];
      rows.forEach((row, i) => {
        const o = I[LAY[i].k];
        row.style.setProperty('--o', o.toFixed(3));
        if (o > I[best.k] + .001) best = LAY[i];
      });
      if (pyramid && p > .5 && I.base >= I.heart) best = LAY.find(L => L.k === 'base') || best;
      rows.forEach((row, i) => row.classList.toggle('is-active', LAY[i] === best));
      if (best.k !== activeK) {
        activeK = best.k;
        phaseEl.textContent = `${best.label} · ${best.phase}`;
        descEl.textContent = best.desc;
        if (ghost) { ghost.classList.add('is-swap'); setTimeout(() => { ghost.textContent = best.ghost; ghost.classList.remove('is-swap'); }, 260); }
        if (aura) { const c = layCols[LAY.indexOf(best)] || []; aura.setColors(c.concat(c.slice(0, 1), layCols[0] || [])); }
      }
      range.value = Math.round(p * 1000);
      fill.style.setProperty('--p', p);
      timeEl.textContent = fmtT(p);
    }
    render(0);

    /* Desktop: scroll-gesteuert (gepinnt) · Mobil: Slider + Autoplay */
    const pinMQ = window.matchMedia('(min-width: 990px)');
    let pinned = false, playing = false, raf = 0, autoDone = false;
    const jTop = () => J.getBoundingClientRect().top + window.scrollY;
    const total = () => Math.max(1, J.offsetHeight - window.innerHeight);
    function setupPin() {
      pinned = pinMQ.matches && !reduced();
      J.classList.toggle('is-pinned', pinned);
      if (pinned) onScroll();
    }
    function onScroll() { if (!pinned) return; render(-J.getBoundingClientRect().top / total()); }
    window.addEventListener('scroll', () => { if (pinned && !playing) requestAnimationFrame(onScroll); }, { passive: true });
    window.addEventListener('resize', () => { if (pinned) onScroll(); }, { passive: true });
    pinMQ.addEventListener ? pinMQ.addEventListener('change', setupPin) : pinMQ.addListener(setupPin);
    setupPin();

    function stop() { playing = false; cancelAnimationFrame(raf); playBtn.classList.remove('is-playing'); playBtn.setAttribute('aria-label', 'Duftreise abspielen'); }
    function play() {
      if (playing) return stop();
      playing = true; playBtn.classList.add('is-playing'); playBtn.setAttribute('aria-label', 'Duftreise pausieren');
      let start = null, from = P >= .99 ? 0 : P;
      const dur = 9000 * (1 - from) + 600;
      const step = ts => {
        if (!playing) return;
        if (start == null) start = ts;
        const k = clamp((ts - start) / dur), p = from + (1 - from) * k;
        if (pinned) { window.scrollTo(0, jTop() + p * total()); render(p); } else render(p);
        if (k < 1) raf = requestAnimationFrame(step); else stop();
      };
      raf = requestAnimationFrame(step);
    }
    playBtn.addEventListener('click', play);
    ['wheel', 'touchstart', 'keydown'].forEach(ev => window.addEventListener(ev, e => { if (playing && !(e.target === playBtn)) stop(); }, { passive: true }));
    range.addEventListener('input', () => {
      stop();
      const p = range.value / 1000;
      if (pinned) window.scrollTo(0, jTop() + p * total());
      render(p);
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        if (e.isIntersecting && !pinned && !autoDone && !reduced()) { autoDone = true; setTimeout(() => { if (!playing && P < .02) play(); }, 500); }
      }, { threshold: .55 }).observe(J);
    }
  } else if (J) {
    J.hidden = true;
  }

  MFL.fx = { FAMC, colOf, esc, clamp };
})();